import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeSectionRead from './cnaeSectionRead.action.json' assert { type: 'json' }

const cnaeSectionReadDefinition = defineReadAutoAction(cnaeSectionRead, 'cnaeSection')

export default cnaeSectionReadDefinition
